var _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8TuvaluCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M44,24c0,11.046-8.954,20-20,20S4,35.046,4,24c0-2.216,0.36-4.348,1.026-6.341 C6.311,13.812,14.489,11,14.489,11s0.04-4.693,1.507-5.334C18.447,4.594,21.154,4,24,4C35.046,4,44,12.954,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M24,4C15.129,4,7.618,9.781,5,17.777V18h20V4.042C24.667,4.025,24.337,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16,8.594V5.675c-1.432,0.626-2.767,1.424-4,2.352V8.31l-0.206-0.128 c-3.105,2.399-5.483,5.683-6.753,9.483L12,13.32V18h4v-4.965L23.949,18H25v-2.609L21.171,13H25V9h-4.421L25,6.238V4.05 C24.667,4.034,24.338,4,24,4c-0.235,0-0.464,0.027-0.697,0.035L16,8.594z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M13,12v6h2v-6h10v-2H15V6.157c-0.689,0.348-1.36,0.725-2,1.148V10H9.729 c-0.613,0.625-1.174,1.299-1.701,2H13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M11.641,13H9.898l-3.972,2.479c-0.229,0.484-0.437,0.977-0.627,1.481L11.641,13z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M24.213,4.011L16.223,9h1.746L25,4.609V4.05C24.738,4.037,24.478,4.014,24.213,4.011z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "25,15.934 20.301,13 18.559,13 25,17.02"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffea00",
    points: "37.178,13.224 37.706,14.781 39.35,14.802 38.032,15.785 38.52,17.355 37.178,16.405 35.836,17.355 36.324,15.785 35.006,14.802 36.65,14.781"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffea00",
    points: "37.234,24.297 37.761,25.854 39.406,25.875 38.087,26.858 38.576,28.428 37.234,27.478 35.891,28.428 36.38,26.858 35.062,25.875 36.706,25.854"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffea00",
    points: "32.17,27.691 32.698,29.248 34.342,29.269 33.024,30.252 33.513,31.822 32.17,30.872 30.828,31.822 31.317,30.252 29.998,29.269 31.643,29.248"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffea00",
    points: "15.45,34.869 15.977,36.426 17.622,36.447 16.303,37.43 16.792,39 15.45,38.05 14.107,39 14.596,37.43 13.278,36.447 14.922,36.426"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffea00",
    points: "20.78,27.795 22.134,28.728 23.465,27.761 22.996,29.337 24.327,30.303 22.683,30.345 22.175,31.909 21.627,30.358 19.983,30.358 21.289,29.359"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffea00",
    points: "20.808,33.637 22.162,34.57 23.492,33.603 23.024,35.179 24.354,36.146 22.71,36.187 22.203,37.751 21.655,36.2 20.011,36.201 21.317,35.201"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffea00",
    points: "26.817,32.135 28.172,33.068 29.502,32.101 29.033,33.677 30.364,34.643 28.72,34.685 28.212,36.249 27.665,34.698 26.02,34.699 27.326,33.699"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffea00",
    points: "26.873,19.476 28.227,20.409 29.557,19.442 29.089,21.018 30.419,21.985 28.775,22.026 28.268,23.59 27.72,22.039 26.076,22.04 27.382,21.04"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffea00",
    points: "31.936,17.696 33.291,18.629 34.621,17.662 34.152,19.238 35.483,20.204 33.839,20.245 33.331,21.81 32.784,20.259 31.139,20.259 32.445,19.26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8TuvaluCircular);
export default __webpack_public_path__ + "static/media/icons8-tuvalu-circular.3759a1837e0a4a3b53c631245d1063e8.svg";
export { ForwardRef as ReactComponent };